import PropTypes from 'prop-types';
import React from 'react';
import Dropdown from './Dropdown';
import { withEnums } from '../../../decorators';

function IndustryDropdown(_ref) {
  var value = _ref.value,
      placeholder = _ref.placeholder,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      linesOfBusiness = _ref.linesOfBusiness,
      classNamePrefix = _ref.classNamePrefix;
  var availableOptions = linesOfBusiness.map(function (line) {
    return {
      label: line.title,
      value: line.title
    };
  });
  return React.createElement(Dropdown, {
    placeholder: placeholder,
    options: availableOptions,
    value: value,
    onChange: onChange,
    onFocus: onFocus,
    onBlur: onBlur,
    classNamePrefix: classNamePrefix
  });
}

IndustryDropdown.propTypes = {
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  linesOfBusiness: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string
  })),
  classNamePrefix: PropTypes.string
};
IndustryDropdown.defaultProps = {
  placeholder: 'Industry',
  classNamePrefix: 'SearchableDropdown'
};
export default withEnums('linesOfBusiness')(IndustryDropdown);